module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-4-big-42d079f258be64150e4e90af6905ff4c.jpg";